import { PropsWithChildren, useMemo, useState } from 'react';

import { ProductionCalendarContext } from './productionCalendarContext';

export const ProductionCalendarProvider = ({ children }: PropsWithChildren) => {
  const [currentDate, setCurrentDate] = useState<Date>(new Date());

  const value = useMemo(
    () => ({ currentDate, setCurrentDate }),
    [currentDate, setCurrentDate]
  );

  return (
    <ProductionCalendarContext.Provider value={value}>
      {children}
    </ProductionCalendarContext.Provider>
  );
};
